<script>
import Component from '~/sites/shop/pages/index'
export default {
  extends: Component,
  async asyncData(context) {
    await context.store.dispatch('category/FETCH_HOMEPAGE_CATEGORIES')
    const result = await Component.asyncData(context)
    await context.app.apolloProvider.defaultClient.cache.reset()
    return result
  },
}
</script>
